"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Select = _interopRequireDefault(require("@material-ui/core/Select"));

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var DropDownList = function DropDownList(_ref) {
  var items = _ref.items,
      onChange = _ref.onChange,
      value = _ref.value,
      renderItem = _ref.renderItem,
      other = _objectWithoutProperties(_ref, ["items", "onChange", "value", "renderItem"]);

  return _react.default.createElement(_Select.default, _extends({
    onChange: onChange,
    variant: "outlined",
    value: value
  }, other), Object.keys(items).map(function (key) {
    return _react.default.createElement(_MenuItem.default, {
      key: key,
      value: key
    }, renderItem(items[key]));
  }));
};

DropDownList.propTypes = {
  /** array eller objekt med verdier */
  items: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.object]).isRequired,

  /** funksjon som kalles ved endring av valgt verdi */
  onChange: _propTypes.default.func,

  /** valgt verdi */
  value: _propTypes.default.any.isRequired,

  /** funksjon som returnerer node som render-es */
  renderItem: _propTypes.default.func
};
DropDownList.defaultProps = {
  onChange: function onChange() {},
  renderItem: function renderItem(item) {
    return item;
  }
};
var _default = DropDownList;
exports.default = _default;